<template>
  <div :class="['search-events__list', { card: withCard }]">
    <div class="search-events__total" v-if="events.length > 0">
      {{ total }}
      {{ total === 1 ? 'event' : 'events' }}
    </div>
    <div class="search-events__item" v-for="(event, index) in events"
      :key="event.eventId || event.id || event._id || event.slug || event.link || index">
      <event-preview :event-data="event" :is-active="false" />

      <el-divider v-if="showDividers && index < events.length - 1" />
    </div>

    <el-pagination 
      v-if="events && events.length > 0 && limit && limit > 0"
      layout="prev, pager, next"
      :total="total"
      hide-on-single-page
      :page-size="limit"
      :current-page="currentPage"
      @current-change="onNavigate"
    />

    <div class="search-events__empty-text" v-if="total !== null && events.length === 0">
      <slot name="empty">There are no events matching your search query</slot>
    </div>
  </div>
</template>

<script>
import EventPreview from '@/components/events/EventPreview.vue';

export default {
  name: 'EventPreviewList',
  components: { EventPreview },
  props: {
    events: {
      type: Array,
      default: () => [],
      // @ts-ignore: Suppress type error for _id property
    },
    // Use null until you know the result count; shows empty message when 0
    total: {
      type: Number,
      default: null,
    },
    withCard: {
      type: Boolean,
      default: true,
    },
    showDividers: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    onNavigate: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.search-events {
  &__result {
    margin-top: var(--global-dimension-size-350);
  }

  &__total {
    font-size: var(--font-size-300);
    margin-bottom: var(--global-dimension-size-300);
  }

  &__empty-text {
    font-size: var(--font-size-300);
  }
}
</style>
